/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React from 'react';

// ours
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// styles
import styles from './SectionHeader.module.scss';

interface SectionHeaderProps {
    children: string;
}

export default function SectionHeader(props: SectionHeaderProps): JSX.Element {
    return (
        <Typography variant={TypographyVariants.HEADING_XS} className={styles.sectionHeader}>
            {props.children}
        </Typography>
    );
}
